import React, { useState, useRef, useEffect } from 'react';
import Logo from './Logo';
import Button from './Button';
import MenuOverlay from './MenuOverlay';

export default function Masthead() {
  const [menuOpen, setMenuOpen] = useState(false);
  const headerRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (!menuOpen) return;
    const handler = (e: MouseEvent) => {
      if (headerRef.current && !headerRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [menuOpen]);

  return (
    <header
      ref={headerRef}
      className="sticky top-0 z-50 w-full overflow-visible"
    >
      {/* Background — clips to header height only */}
      <div className="absolute inset-0 border-avaris border-b backdrop-blur-sm pointer-events-none" />

      {/* Content row */}
      <div className="relative flex items-center justify-between px-8 py-4">
        {/* Left: logo + tagline */}
        <div className="flex items-center gap-8 min-w-0">
          <a href="/">
            <Logo />
          </a>
          <span className="font-ibm type-nav-tagline text-black hidden sm:block">
            A.I. driven product development co.
          </span>
        </div>

        {/* Right: Get In Touch — menu circle floats to its left via absolute */}
        <a href="#get-in-touch"><Button>Get In Touch</Button></a>
      </div>

      {/* Floating menu circle — positioned before (left of) Get In Touch, extends below header */}
      <button
        className="menu-circle z-100"
        onClick={() => setMenuOpen((v) => !v)}
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
      >
        <span className="font-trispace type-nav-label text-white">
          {menuOpen ? 'CLOSE' : 'MENU'}
        </span>
      </button>

      <MenuOverlay open={menuOpen} onClose={() => setMenuOpen(false)} />
    </header>
  );
}
